import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const OurStoriesEditor = () => {
  const columns = [
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'title_en', label: 'Title (EN)', type: 'text' },
    { key: 'title_ms', label: 'Title (MS)', type: 'text' },
    { key: 'subtitle_en', label: 'Subtitle (EN)', type: 'text' },
    { key: 'subtitle_ms', label: 'Subtitle (MS)', type: 'text' },
    { key: 'cover_image_url', label: 'Cover Image', type: 'image' },
    { key: 'description1_en', label: 'Description 1 (EN)', type: 'textarea' },
    { key: 'description1_ms', label: 'Description 1 (MS)', type: 'textarea' },
    { key: 'stories_image_url', label: 'Story Image', type: 'image' },
    { key: 'description2_en', label: 'Description 2 (EN)', type: 'textarea' },
    { key: 'description2_ms', label: 'Description 2 (MS)', type: 'textarea' },
  ];

  return <GenericTableEditor tableName="our_stories" columns={columns} title="Our Stories Manager" />;
};

export default OurStoriesEditor;
